// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  pageCongratz: '/congratz',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  dash: {
    root: path(ROOTS_DASHBOARD, '/dash'),
    general: path(ROOTS_DASHBOARD, '/dash/general'),
    path: path(ROOTS_DASHBOARD, '/dash/path'),
  },
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (id) => path(ROOTS_DASHBOARD, `/user/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  config: {
    root: path(ROOTS_DASHBOARD, '/config'),
    modify: path(ROOTS_DASHBOARD, '/config/modify'),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    new: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    demoView: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    list: path(ROOTS_DASHBOARD, '/invoice/list'),
    new: path(ROOTS_DASHBOARD, '/invoice/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (title) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
  // Nuevos Menus
  alarm: {
    root: path(ROOTS_DASHBOARD, '/alarm'),
    list: path(ROOTS_DASHBOARD, '/alarm/list'),
    // new: path(ROOTS_DASHBOARD, '/alarm/new'),
    // view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  cliente: {
    root: path(ROOTS_DASHBOARD, '/cliente'),
    list: path(ROOTS_DASHBOARD, '/cliente/list'),
    new: path(ROOTS_DASHBOARD, '/cliente/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/cliente/${id}/edit`),
  },
  menu: {
    root: path(ROOTS_DASHBOARD, '/menu'),
    select: (rut) => path(ROOTS_DASHBOARD, `/menu/select/${rut}`),
  },
  tree: {
    root: path(ROOTS_DASHBOARD, '/tree'),
    list: path(ROOTS_DASHBOARD, '/tree/list'),
    new: path(ROOTS_DASHBOARD, '/tree/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/tree/${id}/edit`),
  },
  // specialtyManagement: {
  //   root: path(ROOTS_DASHBOARD, '/specialty'),
  //   list: path(ROOTS_DASHBOARD, '/specialty/list'),
  // },
  // disciplineManagement: {
  //   root: path(ROOTS_DASHBOARD, '/discipline'),
  //   list: path(ROOTS_DASHBOARD, '/discipline/list'),
  // },
  // failureManagement: {
  //   root: path(ROOTS_DASHBOARD, '/failure'),
  //   list: path(ROOTS_DASHBOARD, '/failure/list'),
  // },
  specialty: {
    root: path(ROOTS_DASHBOARD, '/specialty'),
    list: path(ROOTS_DASHBOARD, '/specialty/list'),
  },
  discipline: {
    root: path(ROOTS_DASHBOARD, '/discipline'),
    list: path(ROOTS_DASHBOARD, '/discipline/list'),
  },
  wallpaper: {
    root: path(ROOTS_DASHBOARD, '/wallpaper'),
    list: path(ROOTS_DASHBOARD, '/wallpaper/list'),
  },
  failure: {
    root: path(ROOTS_DASHBOARD, '/failure'),
    list: path(ROOTS_DASHBOARD, '/failure/list'),
  },
  profile: {
    root: path(ROOTS_DASHBOARD, '/profile'),
    new: path(ROOTS_DASHBOARD, '/profile/new'),
    list: path(ROOTS_DASHBOARD, '/profile/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/profile/${id}/edit`),
  },
  planning: {
    root: path(ROOTS_DASHBOARD, '/planning'),
    list: path(ROOTS_DASHBOARD, '/planning/list'),
    calendar: path(ROOTS_DASHBOARD, '/planning/calendar'),
    toPlan: (id) => path(ROOTS_DASHBOARD, `/planning/${id}/to-plan`),
  },
  area: {
    root: path(ROOTS_DASHBOARD, '/area'),
    list: path(ROOTS_DASHBOARD, '/area/list'),
    new: path(ROOTS_DASHBOARD, '/area/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/area/${id}/edit`),
  },
  division: {
    root: path(ROOTS_DASHBOARD, '/division'),
    list: path(ROOTS_DASHBOARD, '/division/list'),
    new: path(ROOTS_DASHBOARD, '/division/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/division/${id}/edit`),
  },
  place: {
    root: path(ROOTS_DASHBOARD, '/place'),
    list: path(ROOTS_DASHBOARD, '/place/list'),
    new: path(ROOTS_DASHBOARD, '/place/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/place/${id}/edit`),
  },
  company: {
    root: path(ROOTS_DASHBOARD, '/company'),
    list: path(ROOTS_DASHBOARD, '/company/list'),
    new: path(ROOTS_DASHBOARD, '/company/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/place/${id}/edit`),
  },
  location: {
    root: path(ROOTS_DASHBOARD, '/location'),
    list: path(ROOTS_DASHBOARD, '/location/list'),
    new: path(ROOTS_DASHBOARD, '/location/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/location/${id}/edit`),
  },
  order: {
    root: path(ROOTS_DASHBOARD, '/order'),
    list: path(ROOTS_DASHBOARD, '/order/list'),
    new: path(ROOTS_DASHBOARD, '/order/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/order/${id}/view`),
    edit: (id) => path(ROOTS_DASHBOARD, `/order/${id}/edit`),
  },
  orderQr: {
    root: path(ROOTS_DASHBOARD, '/orderQr'),
    list: path(ROOTS_DASHBOARD, '/orderQr/list'),
    new: path(ROOTS_DASHBOARD, '/orderQr/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/orderQr/${id}/view`),
    edit: (id) => path(ROOTS_DASHBOARD, `/orderQr/${id}/edit`),
  },
  preventiveMaintenance: {
    root: path(ROOTS_DASHBOARD, '/preventive-maintenance'),
    list: path(ROOTS_DASHBOARD, '/preventive-maintenance/list'),
    new: path(ROOTS_DASHBOARD, '/preventive-maintenance/new'),
  },
  notification: {
    root: path(ROOTS_DASHBOARD, '/dashboard/notifications'),
    list: path(ROOTS_DASHBOARD, '/dashboard/notifications/list'),
    // new: path(ROOTS_DASHBOARD, '/preventive-maintenance/new'),
  },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
